import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import Loading from './loading.js'
import Sync from './sync.js'

const Wrapper = styled.div`
	width: ${props => props.width}px;
	height: ${props => props.height}px;
	display: block;
	animation-name: spin;
	animation-duration: 2000ms;
	animation-iteration-count: infinite;
	animation-timing-function: linear;
	@keyframes spin {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}
`

const Spin = ({ type, ...restProps }) =>
	/*#__PURE__*/ React.createElement(
		Wrapper,
		restProps,
		type === 'loading'
			? /*#__PURE__*/ React.createElement(Loading, restProps)
			: /*#__PURE__*/ React.createElement(Sync, restProps),
	)

Spin.propTypes = {
	type: PropTypes.oneOf(['spin', 'loading']),
	width: PropTypes.number,
	height: PropTypes.number,
	color: PropTypes.string,
}
Spin.defaultProps = {
	width: 64,
	height: 64,
	type: 'loading',
	color: 'black',
}

export default Spin
